<template>
  <div class="app-home">
    <router-view />
  </div>
</template>

<style scoped>
.app-home {
  min-height: 100vh;
  min-height: 100svh;
}
.app-main {
  min-height: 100vh;
  min-height: 100svh;
}
</style>
